<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ix"></a>
<h2 class="fm-title"><span class="bold">Foreword</span></h2>
<p class="noindent">In 2013, I was sitting in the Aircrewmen’s Crew room of 848 Naval Air Commando Squadron at Royal Naval Air Station Yeovilton (RNAS Yeovilton). All the crewman were telling stories (DITs); I joined in and Buck Taylor, one of the instructors, said I should write a book as the DITs went on for quite a while, and the fact that I had been around the job for some forty-five years then (I joined in 1968) meant I had a few stories to tell.</p>
<p class="indent">So, I have decided to do as he asked and we’ll see how it goes.</p>
<a id="page_x"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Forword.vue?91542c10